<div class="reconnect">
  <div class="arrow-up"></div>
  <div class="baloon" *ngIf="!isSuccess">
    <div class='div-top'>
<!--      <lottie-animation-view [options]="lottieConfig" [width]="245" [height]="80"-->
<!--        (animCreated)="handleAnimation($event)">-->
<!--      </lottie-animation-view>-->
      <ng-lottie width="245px" [options]="optionsLottie"></ng-lottie>
      <span class="reconnect-msg-1" [innerHtml]='offlineText'>{{offlineText}}</span>
    </div>
    <div class="div-bottom" *ngIf="!bothDown">
      <button mat-stroked-button class="sm" (click)="closeModal(false)">Continuar navegando</button>
    </div>
    <div class="div-bottom" *ngIf="bothDown">
      <button mat-stroked-button class="sm" (click)="closeModal(true)">FAZER LOGIN NOVAMENTE</button>
      <button mat-raised-button class="sm" (click)="closeModal(false)">VER OFFLINE</button>
    </div>
  </div>
  <div class="baloon" *ngIf="isSuccess">
    <div class='div-top'>
<!--      <lottie-animation-view [options]="lottieConfigSuccess" [width]="245" [height]="80"-->
<!--        (animCreated)="handleAnimation($event)">-->
<!--      </lottie-animation-view>-->
      <ng-lottie width="245px" [options]="optionsLottieSuccess"></ng-lottie>
      <span class="reconnect-msg-1">Os serviços de cotação e negociação foram reconectados </span>
    </div>
  </div>
</div>
